/**
 * Real Customer Testimonials Slider
 */
(function () {
    document.querySelectorAll('.rct-section').forEach(function (section) {
        var slides = section.querySelectorAll('.rct-slide');
        var dots = section.querySelectorAll('.rct-dot');
        var stats = section.querySelectorAll('.rct-stat-item');
        var prevBtn = section.querySelector('.rct-arrow-prev');
        var nextBtn = section.querySelector('.rct-arrow-next');
        var currentIndex = 0;
        var totalSlides = slides.length;
        var autoplayInterval = null;

        if (totalSlides <= 0) return;

        var autoplay = section.dataset.sectionId
            ? false
            : false;

        // Read autoplay settings from the section element
        var sectionEl = section;

        function goToSlide(index) {
            if (index < 0) index = totalSlides - 1;
            if (index >= totalSlides) index = 0;

            // Remove active from current
            slides[currentIndex].classList.remove('active');
            if (dots[currentIndex]) dots[currentIndex].classList.remove('active');
            if (stats[currentIndex]) stats[currentIndex].classList.remove('active');

            // Set new active
            currentIndex = index;
            slides[currentIndex].classList.add('active');
            if (dots[currentIndex]) dots[currentIndex].classList.add('active');
            if (stats[currentIndex]) stats[currentIndex].classList.add('active');
        }

        function nextSlide() {
            goToSlide(currentIndex + 1);
        }

        function prevSlide() {
            goToSlide(currentIndex - 1);
        }

        // Arrow click
        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                nextSlide();
                resetAutoplay();
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                prevSlide();
                resetAutoplay();
            });
        }

        // Dot click
        dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
                var dotIndex = parseInt(dot.getAttribute('data-dot-index'), 10);
                goToSlide(dotIndex);
                resetAutoplay();
            });
        });

        // Touch/Swipe support
        var touchStartX = 0;
        var touchEndX = 0;
        var slider = section.querySelector('.rct-slider');

        if (slider) {
            slider.addEventListener('touchstart', function (e) {
                touchStartX = e.changedTouches[0].screenX;
            }, { passive: true });

            slider.addEventListener('touchend', function (e) {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe();
            }, { passive: true });
        }

        function handleSwipe() {
            var diff = touchStartX - touchEndX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    nextSlide();
                } else {
                    prevSlide();
                }
                resetAutoplay();
            }
        }

        // Autoplay
        function startAutoplay() {
            var speedAttr = section.querySelector('[data-autoplay-speed]');
            var speed = 5000;
            autoplayInterval = setInterval(nextSlide, speed);
        }

        function resetAutoplay() {
            if (autoplayInterval) {
                clearInterval(autoplayInterval);
                autoplayInterval = null;
            }
        }

        // Keyboard support
        section.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') {
                prevSlide();
                resetAutoplay();
            } else if (e.key === 'ArrowRight') {
                nextSlide();
                resetAutoplay();
            }
        });

        // Initialize - ensure first slide is active
        goToSlide(0);
    });
})();
